import { render, staticRenderFns } from "./vehicleservicehistory.html?vue&type=template&id=2452bcc3&external"
import script from "./vehicleservicehistory.vue?vue&type=script&lang=js"
export * from "./vehicleservicehistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports